import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Tooltip
} from "antd";
import { withRouter } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import "./index.less";
import { platformApi } from "../../../api";
import { ContextAPI } from "../../../ContextAPI";

import ServiceScheduleTable from "./ServiceScheduleTable";
import ServiceScheduleModal from "./ServiceScheduleModal";

const { Title, Text } = Typography;
const { Search } = Input;
const { Item } = Menu;

const ServiceScheduleMaster = (props) => {
  const { loginCredintials } = useContext(ContextAPI);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const [limit, setLimit] = useState(10);
  const [addFlag, setAddFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [selected, setSelected] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const getMenu = () => {
    let size = Math.ceil(count / 10);
    const menus = [10];
    for (let itr = 2; itr <= (size <= 10 ? size : 10); itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu); setPage(1); }} key={menu}>
        {menu}
      </Item>
    ));
  };

  const fetchData = (searchTerm = search, currentPage = page, currentLimit = limit) => {
    setSpinning(true);
    platformApi
      .post("/api/serviceScheduleMaster/get", {
        searchString: searchTerm,
        page: currentPage,
        size: currentLimit
      })
      .then((res) => {
        setSpinning(false);
        if (res.data && res.data.code === 200) {
          const result = res.data.response?.data || {};
          setDataSource(result.ServiceSchedules || []);
          setCount(result.count || 0);
        } else {
          setDataSource([]);
          setCount(0);
        }
      })
      .catch((err) => {
        setSpinning(false);
        console.error(err);
        message.error("Failed to load Service Schedules");
      });
  };

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        const sub = (each.subModule || "").toLowerCase().replace(/_/g, " ").trim();
        if (sub === "service schedule") {
          if (each.access) {
            if (each.access.create) setCreateAccess(true);
            if (each.access.update) setModifyAccess(true);
            if (each.access.delete) setDeleteAccess(true);
          }
        }
      });
    }
  }, [loginCredintials]);

  useEffect(() => {
    fetchData(search, page, limit);
  }, [page, limit, search]);

  const handleDelete = (id) => {
    setSpinning(true);
    platformApi
      .delete(`/api/serviceScheduleMaster/${id}`)
      .then((res) => {
        setSpinning(false);
        const data = res.data || {};
        const responseData = data.response || {};
        if (data.code === 200 && responseData.code !== 400 && responseData.code !== 404 && responseData.code !== 500) {
          message.success("Service Schedule deleted successfully");
          fetchData(search, page, limit);
        } else {
          const errMsg =
            responseData.message ||
            data.message ||
            data.msg ||
            "Cannot delete Service Schedule";
          message.error(errMsg);
        }
      })
      .catch((err) => {
        setSpinning(false);
        console.error(err);
        message.error("Error deleting Service Schedule");
      });
  };

  const handleOpenModal = (record = null, editable = true) => {
    setSelected(record);
    setEditFlag(editable);
    setAddFlag(true);
  };

  const handleCloseModal = () => {
    setSelected(null);
    setEditFlag(false);
    setAddFlag(false);
  };

  const handleSearch = (val) => {
    setSearch(val);
    setPage(1);
  };

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          Service Schedule Master [{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={<Menu>{getMenu()}</Menu>} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Base Model or Category"
          onSearch={(event) => {
            setPage(1);
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch("");
              setPage(1);
            }
          }}
        />
        <Button
          onClick={() => {
            handleOpenModal(null, true);
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Service Schedule
        </Button>
      </div>

      <ServiceScheduleTable
        dataSource={dataSource}
        spinner={spinning}
        openModal={handleOpenModal}
        delete={handleDelete}
        modify={modifyAccess}
        deleteAccess={deleteAccess}
        pagination={{
          onChange: (newPage) => {
            setPage(newPage);
          },
          pageSize: limit,
          current: page,
          showQuickJumper: true,
          defaultCurrent: 1,
          total: count,
        }}
      />

      <ServiceScheduleModal
        open={addFlag}
        close={handleCloseModal}
        data={selected}
        modify={modifyAccess}
        editable={editFlag}
        emitData={() => {
          setPage(1);
          fetchData(search, 1, limit);
        }}
      />
    </div>
  );
};

export default withRouter(ServiceScheduleMaster);

